import type { PublicUser } from '../../types';
import type { View } from '../../constants';

interface Props {
  view: View;
  user: PublicUser | null;
  authLoading: boolean;
  onNavigate: (view: View) => void;
  onLogin: () => void;
  onLogout: () => void;
}
export function AppHeader({ view, user, authLoading, onNavigate, onLogin, onLogout }: Props) {
  return (
    <header className="topbar">
      <div className="topbar-inner">
        <button
          className="brand brand-button"
          onClick={() => onNavigate('evaluate')}
          aria-label="返回评测首页"
        >
          <span className="brand-mark">G</span>
          <span>
            <strong>GEO文章评测</strong>
            <small>AI 搜索内容质量诊断</small>
          </span>
        </button>
        <nav className="nav" aria-label="主要导航">
          <button
            className={view === 'evaluate' ? 'active' : ''}
            onClick={() => onNavigate('evaluate')}
          >
            文章评测
          </button>
          <button
            className={view === 'reports' ? 'active' : ''}
            onClick={() => onNavigate('reports')}
          >
            我的报告
          </button>
        </nav>
        <div className="top-actions">
          {authLoading ? (
            <span className="muted">登录状态加载中</span>
          ) : user ? (
            <>
              <span className="account-label">
                {user.company_name} · {user.masked_mobile}
              </span>
              <button className="btn secondary compact" onClick={onLogout}>
                退出
              </button>
            </>
          ) : (
            <button className="btn compact" onClick={onLogin}>
              登录 / 注册
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
